module.exports = __webpack_public_path__ + "static/media/logo-fair-corretora-cambio.204e04bd.png";